var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09863 14.5615C7.9147 13.1986 12.0853 13.1986 15.9014 14.5615C17.0099 14.9576 17.75 16.0074 17.75 17.1846V18.5C17.75 20.1438 16.2942 21.4062 14.667 21.1738L13.7119 21.0381C11.2498 20.6864 8.75022 20.6864 6.28809 21.0381L5.33301 21.1738C3.70576 21.4062 2.25 20.1438 2.25 18.5V17.1846C2.25004 16.0074 2.9901 14.9576 4.09863 14.5615ZM15.3965 15.9736C11.9068 14.7274 8.09322 14.7274 4.60352 15.9736C4.09181 16.1564 3.75004 16.6412 3.75 17.1846V18.5C3.75 19.231 4.39744 19.7928 5.12109 19.6895L6.0752 19.5527C8.67828 19.1809 11.3217 19.1809 13.9248 19.5527L14.8789 19.6895C15.6026 19.7928 16.25 19.231 16.25 18.5V17.1846C16.25 16.6412 15.9082 16.1564 15.3965 15.9736Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.5C19.4142 8.5 19.75 8.83579 19.75 9.25V10.5H21C21.4142 10.5 21.75 10.8358 21.75 11.25C21.75 11.6642 21.4142 12 21 12H19.75V13.25C19.75 13.6642 19.4142 14 19 14C18.5858 14 18.25 13.6642 18.25 13.25V12H17C16.5858 12 16.25 11.6642 16.25 11.25C16.25 10.8358 16.5858 10.5 17 10.5H18.25V9.25C18.25 8.83579 18.5858 8.5 19 8.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C12.6234 2.5 14.75 4.62665 14.75 7.25C14.75 9.87335 12.6234 12 10 12C7.37665 12 5.25 9.87335 5.25 7.25C5.25 4.62665 7.37665 2.5 10 2.5ZM10 4C8.20507 4 6.75 5.45507 6.75 7.25C6.75 9.04493 8.20507 10.5 10 10.5C11.7949 10.5 13.25 9.04493 13.25 7.25C13.25 5.45507 11.7949 4 10 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.b23553db948a51170f1a5eb674d79111.svg";
export { ForwardRef as ReactComponent };